import { useEffect, useState } from 'react';
import { useMusicControl } from '../hooks/useMusicControl';
import { ButtonCard } from './ui/card';
import { useAuth } from '../hooks/useAuth';

export function RequestControlDialog({ onClose, onRequestSent }: { onClose: () => void, onRequestSent: () => void }) {
  const { screenInfo } = useAuth()
  const { controlInfo, requestControl } = useMusicControl(screenInfo?.id, screenInfo?.location_id, screenInfo?.group_id);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (controlInfo?.request_status === 'pending') {
      setShowSuccess(true);
    }
  }, [controlInfo?.request_status]);

  const handleRequest = async () => {
    try {
      await requestControl.mutateAsync();
      onRequestSent()
    } catch (error) {
      console.error('Failed to request control:', error);
    }
  };

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        {showSuccess ? (
          <div className="text-center">
            <h3 className="mb-2 text-lg font-semibold">Request Sent!</h3>
            <p className="text-gray-600">Waiting for the owner to approve your request...</p>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="text-center">
              <h3 className="mb-2 text-lg font-semibold">Request Music Control</h3>
              <p className="text-gray-600">
                You need permission from the owner to control music in this location.
              </p>
            </div>
            <div className="flex justify-end gap-3">
              <ButtonCard
                onClick={onClose}
                variant="outline"
                className="px-4 py-2"
              >
                Cancel
              </ButtonCard>
              <ButtonCard
                onClick={handleRequest}
                disabled={requestControl.isPending}
                className="px-4 py-2"
              >
                {requestControl.isPending ? 'Requesting...' : 'Request Control'}
              </ButtonCard>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}